var lib_core      = require("lib-core");
var lib_geometry  = require("lib-geometry");

var VerticalHandleModel = require("./verticalHandleModel.js");
var VerticalHandleView = require("./verticalHandleView.js");

var Editor3d = require("./../../editor3d/editor3dController.js");

var VerticalHandleController = function(archLayers, dependencies, options) {
    lib_core.Controller.call(this, archLayers, dependencies, options);
};
lib_core.inherit(VerticalHandleController, lib_core.Controller);
VerticalHandleController.inject = {
    editor3d : Editor3d
};

module.exports = VerticalHandleController;

VerticalHandleController.prototype.handleId = "moveVertical";

VerticalHandleController.prototype.createModel = function () {
    var editor3dModel = this.editor3d.getModel();

    return new VerticalHandleModel(editor3dModel, this.handleId, this.configuration);
};


VerticalHandleController.prototype.createView = function () {
    var editor3dView = this.editor3d.getView();

    return new VerticalHandleView(this.getModel(), editor3dView, this.handleId, this.configuration);
};



